import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import './CustomerModals.scss'

function DebitWallet({ fetchTransaction, fetchUser, setShowDeduct }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [amount, setAmount] = useState(0)
  const [reason, setReason] = useState('')
  const [type, setType] = useState('')

  async function updateDebt() {
    const data = {
      amount,
      type,
      reason,
    }
    if (amount < 1) {
      notify('warn', 'Input Amount')
      return
    }
    if (type.length < 4) {
      notify('warn', 'Transaction type is required')
      return
    }
    if (reason.length < 10) {
      notify('warn', 'Description is too short')
      return
    }
    setCancelLoading(true)
    post(`admin/create-transaction/${id}`, data, null)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Wallet Debited')
          setShowDeduct(false)
          fetchUser()
          fetchTransaction(1, 'all', 10)
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div className='modal-icon icon-blue'>
            <Icon icon='mdi:wallet-outline' />
          </div>
          <h2>Create Wallet Transaction</h2>
          <p>This action will debit or credit the user's wallet balance.</p>
        </div>

        <div className='form-group'>
          <label>Amount (NGN)</label>
          <input
            type='number'
            min={1}
            placeholder='e.g. 10000'
            onChange={(e) => setAmount(parseFloat(e.target.value))}
          />
        </div>

        <div className='form-group'>
          <label>Transaction Type</label>
          <select onChange={(e) => setType(e.target.value)}>
            <option value=''>— Select type —</option>
            <option value='debit'>Debit</option>
            <option value='credit'>Credit</option>
          </select>
        </div>

        <div className='form-group'>
          <label>Description</label>
          <textarea
            rows={4}
            placeholder='Describe the reason for this transaction...'
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={() => setShowDeduct(false)}>
              Cancel
            </button>
            <button className='btn-proceed' onClick={updateDebt}>
              Create Transaction
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default DebitWallet
